import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { TransporterService } from '../../../services/transporter/transporter.service';
import { MatSnackBar } from '@angular/material';
import { validateConfig } from '@angular/router/src/config';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ResourceService } from '../../../services/resource/resource.service';


@Component({
  selector: 'app-addtransporter',
  templateUrl: './addtransporter.component.html',
  styleUrls: ['./addtransporter.component.scss']
})
export class AddtransporterComponent implements OnInit {

  transporterForm: FormGroup;
  transporterName: string;
  transporterPhoneNumber: string;
  transporterAddress1: string;
  transporterAddress2: string;
  transporterAddress3: string;
  pincode: string;
  city: string;
  state: string;
  country: string;
  contactPersonName: string;
  contactPersonPhoneNumber: string;
  contactPersonEmailId: string;
  activityCreatedLog = [];
  activityUpdatedLog = [];
  isAssociatedUnit: boolean = false;
  allBranchesNames = [];

  constructor(
    private formBuilder: FormBuilder,
    private transporterService: TransporterService,
    public snackBar: MatSnackBar,
    public router: Router,
    private datePipe: DatePipe,
    public resourceService: ResourceService,

  ) {
    this.transporterForm = formBuilder.group({
      'transporterName': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'transporterAddress1': [null, Validators.required],
      'transporterAddress2': [null],
      'transporterAddress3': [null],
      'transporterPhoneNumber': [null, Validators.compose([
        Validators.required, Validators.minLength(10), Validators.maxLength(10)
      ])],
      'contactPersonName': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'contactPersonPhoneNumber': [null, Validators.compose([
        Validators.required, Validators.minLength(10), Validators.maxLength(10)
      ])],
      'pincode': [null, Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]*$')
      ])],
      'city': [null, Validators.compose([
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ])],
      'state': [null, Validators.compose([
        Validators.pattern("^[a-zA-Z_ ]+$")
      ])],
      'country': [null, Validators.compose([
        Validators.pattern("^[a-zA-Z_ ]+$")
      ])],
      'contactPersonEmailId': [null, [
        Validators.email
      ]],
      'branchName': [null, [
        Validators.required]]
    });
  }



  openSnackBar(message) {
    let extraClasses;

    this.snackBar.open(message, 'X', {
      duration: 10000,
      panelClass: ['extraClasses']
    });
  }

  onSelectAssociatedUnit() {
    this.isAssociatedUnit = true;
  }

  addTransporter() {
    if (this.transporterForm.valid) {
      console.log(this.transporterForm.value);
      this.transporterService.addTransporter(this.transporterForm.value).subscribe(res => {
        console.log(res);
        this.openSnackBar("Transporter: " + this.transporterForm.value.transporterName + "added successfully");
        this.transporterForm.reset();
        this.router.navigateByUrl('/transporter')
      }, Error => {
        console.log(Error);
        this.transporterForm.reset();
      })

    }


  }


  ngOnInit() {
    this.getAllTransporter();
    this.resourceService.getBranches().subscribe(allBranches => {
      console.log("branches", allBranches);
      this.allBranchesNames = allBranches;
      this.allBranchesNames.sort(function(a, b){
        let branchArea1=a.branchName.toLowerCase(), branchArea2=b.branchName.toLowerCase()
        if (branchArea1 < branchArea2)
            return -1 
        if (branchArea1 > branchArea2)
            return 1
        return 0 
    })
    });
  }

  getAllTransporter() {
    //call get all fleet service here
    this.transporterService.getAllTransporters().subscribe(res => {
      console.log("activitylog", res);
      for (let i = 0; i < res.length; i++) {
        if (res[i]) {
          if (res[i].creationDateTime === res[i].updatedDateTime) {
            this.activityCreatedLog.push({
              driverName: res[i].transporterName,
              createdBy: res[i].updatedByusername,
              creadtedDate: this.datePipe.transform(res[i].creationDateTime, 'dd-MM-yyyy'),
              creadtedTime: res[i].creationDateTime,
            });
          }
          else {
            this.activityUpdatedLog.push({
              driverName: res[i].transporterName,
              updatedBy: res[i].updatedByusername,
              updatedDate: this.datePipe.transform(res[i].updatedDateTime, 'dd-MM-yyyy'),
              updatedTime: res[i].updatedDateTime
            });
          }
        }
      }
    }, Error => {
      console.log(Error);
    });
  }

}
